import emailjs from '@emailjs/browser'

// EmailJS Configuration
// You need to replace these with your actual EmailJS credentials from https://www.emailjs.com/
const EMAILJS_SERVICE_ID = 'service_ca8cii2' // Replace with your EmailJS Service ID
const EMAILJS_TEMPLATE_ID = 'template_00ulqkn' // Replace with your EmailJS Template ID
const EMAILJS_PUBLIC_KEY = 'hk6OXLLY5DSDHE6MN' // Replace with your EmailJS Public Key

export const sendWaitlistNotification = async (userEmail: string): Promise<boolean> => {
  try {
    // Initialize EmailJS with your public key
    emailjs.init(EMAILJS_PUBLIC_KEY)

    // Prepare email template parameters
    const templateParams = {
      to_email: 'contact@azrefy.com',
      user_email: userEmail,
      message: `New user registered in the waitlist with email: ${userEmail}`,
      subject: 'New Waitlist Registration - Azrefy',
    }

    // Send email
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    )

    console.log('Email sent successfully:', response.status, response.text)
    return true
  } catch (error) {
    console.error('Failed to send email notification:', error)
    return false
  }
}
